import { Vue, Component } from "vue-property-decorator";

// Enums/Data
import {
  CONSTANT_FILTERS_START_CHAR,
  ROUTE_QUERY_SEPARATOR
} from "@/data/table";

@Component
export default class AdminOverview extends Vue {
  public get tableId(): string {
    throw new Error("tableId is not set at the child of overviewMixin");
  }

  public get defaultLabel(): string {
    throw new Error("defaultLabel is not set at the child of overviewMixin");
  }

  public get getTableId() {
    return this.getSerialisedConstFilters(this.$route.query[this.tableId]);
  }

  public getSerialisedConstFilters(config: any) {
    let filters = "";
    if (config) {
      const filterParams: any[] = config.split(ROUTE_QUERY_SEPARATOR);
      this.$_.forEach(this.$_.sortBy(filterParams), param => {
        if (param[0] === CONSTANT_FILTERS_START_CHAR) {
          filters += param;
        }
      });
    }
    return filters;
  }
}
